import { Catalog } from '@df/catalog/catalog.interfaces';

export namespace NPageSearch {
    export const OUTLET_BLOCK_ID = 'page-search';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export const SEARCH_MEGANAV_KEY = '@df/catalog/search/search';
    export const SEARCH_OFF_CANVAS_KEY = '@df/catalog/search/search';
    export const SEARCH_OUTLET_COMPONENT_ID = 'page-header-search-outlet';

    // search start
    export interface IBlockDataContent {
        // top links on the side (popular searches)  title
        popularSearchesTitle: string;

        // bottom links with images on the side
        featureLinksTitle: string;
        featureLinks: IFeatureLink[];

        // no result messaging
        noResultTitle: string;
        noResultSubtitle: string;

        // main part cards
        contentCardsTitle?: string;
        contentCards: IContentCard[];
    }

    interface IFeatureLink {
        image?: string;
        label: string;
        link: string;
    }
    interface IContentCard {
        image: string;
        title: string;
        buttonLabel: string;
        link: string;
    }
}
